import script from "./chart.vue?vue&type=script&setup=true&lang=js"
export * from "./chart.vue?vue&type=script&setup=true&lang=js"

import "./chart.vue?vue&type=style&index=0&id=3225d089&lang=less"

const __exports__ = script;

export default __exports__